import uuid from 'uuid/v4'
import * as nativeAxios from 'axios'
import { getTokenBearer } from 'utils/token'
import handleHttpStatus from 'utils/httpStatusErrorHandler'

const BASE_URL = '/api'
const ERROR_TIMEOUT = 'Infelizmente estamos com problemas de conexão, tente novamente mais tarde.'

const createRequestIdInterceptor = axios => {
  axios.interceptors.request.use(config => {
    config.headers['Request-Id'] = uuid('request-id', uuid.DNS)
    return config
  })

  return axios
}

const createAxios = () => {
  const axiosInstance = nativeAxios.create({
    baseURL: BASE_URL
  })

  axiosInstance.interceptors.request.use(config => {
    config.headers.common.Authorization = getTokenBearer()
    return config
  })

  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (!error.response) {
        throw new Error(ERROR_TIMEOUT)
      }
      handleHttpStatus(error.response.status)
      return Promise.reject(error)
    }
  )

  return createRequestIdInterceptor(axiosInstance)
}

export default createAxios()
